module.exports = __webpack_public_path__ + "img/remain-money.995c0ac4.svg";